import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import {
  DetailContext,
  DomainObject,
  TableFieldCells,
  TableFieldColumn,
} from '@eas/common-web';
import { TechnicalObject } from '@models';

export function useColumns<T extends DomainObject>(): TableFieldColumn<T>[] {
  const intl = useIntl();
  const { source } = useContext(DetailContext);
  const to = source?.data as TechnicalObject;

  return [
    {
      name: intl.formatMessage({
        id: 'ZSD__MISMATCHES__TABLE__COLUMN__TODO:',
        defaultMessage: 'Atribút',
      }),
      datakey: 'attributeId',
      sortkey: 'attributeId',
      width: 200,
      CellComponent: function AtributeNameField({ value }: { value: string }) {
        const label =
          (to.attributes ?? []).find((a) => a.id === value)?.type?.name ?? '';
        return <Typography>{label}</Typography>;
      },
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__MISMATCHES__TABLE__COLUMN__TODO:',
        defaultMessage: 'Stará hodnota',
      }),
      datakey: 'oldValue',
      sortkey: 'oldValue',
      width: 200,
      CellComponent: TableFieldCells.TextCell,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__MISMATCHES__TABLE__COLUMN__TODO:',
        defaultMessage: 'Nová hodnota',
      }),
      datakey: 'newValue',
      sortkey: 'newValue',
      width: 200,
      CellComponent: TableFieldCells.TextCell,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__MISMATCHES__TABLE__COLUMN__TODO:',
        defaultMessage: 'Autor',
      }),
      datakey: 'createdBy.name',
      sortkey: 'createdBy.name',
      width: 100,
      CellComponent: TableFieldCells.TextCell,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__MISMATCHES__TABLE__COLUMN__TODO:',
        defaultMessage: 'Dátum zmeny',
      }),
      datakey: 'updated',
      sortkey: 'updated',
      width: 300,
      CellComponent: TableFieldCells.DateCell,
    },
  ];
}
